import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Person, Skeleton } from 'UI';
import { Icon, Button, translate } from '@haldor/ui';
import GuardianMembershipModal from './GuardianMembershipModal';
var ConversationHeader = /*#__PURE__*/function (_Component) {
  function ConversationHeader(props) {
    var _this;
    _classCallCheck(this, ConversationHeader);
    _this = _callSuper(this, ConversationHeader, [props]);
    _defineProperty(_this, "toggleGuardianModal", function () {
      _this.setState({
        guardianModalOpen: !_this.state.guardianModalOpen
      });
    });
    _defineProperty(_this, "renderMembers", function () {
      var _this$props = _this.props,
        conversation = _this$props.conversation,
        user = _this$props.user;
      if (user == null) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            width: 250
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null));
      }
      var users = [];
      conversation.memberships.forEach(function (membership) {
        if (membership.membershipID != user.id) {
          users.push(_objectSpread(_objectSpread({}, membership.user), {}, {
            id: membership.membershipID
          }));
        }
      });
      return users.map(function (user) {
        return /*#__PURE__*/React.createElement("div", {
          key: 'person' + user.id,
          className: "person-wrap"
        }, /*#__PURE__*/React.createElement(Person, {
          person: user
        }));
      });
    });
    _defineProperty(_this, "renderMeta", function () {
      var conversation = _this.props.conversation;
      return conversation.relationships.map(function (relationship, i) {
        if (relationship.referenceType == 'ASSIGNMENT' && relationship.reference != null) {
          return /*#__PURE__*/React.createElement("div", {
            key: i
          }, /*#__PURE__*/React.createElement(Link, {
            to: "/assignment/".concat(relationship.referenceID)
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Assignments"
          }), " ", relationship.reference.title));
        }
        if (relationship.referenceType == 'PLAN' && relationship.reference != null) {
          return /*#__PURE__*/React.createElement("div", {
            key: i
          }, /*#__PURE__*/React.createElement(Link, {
            to: "/plan/".concat(relationship.referenceID)
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Plans"
          }), " ", relationship.reference.title));
        }
        if (relationship.referenceType == 'STUDENT' && relationship.reference != null) {
          return /*#__PURE__*/React.createElement("div", {
            key: i
          }, /*#__PURE__*/React.createElement(Link, {
            to: "#"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "People"
          }), " ", relationship.reference.firstName, " ", relationship.reference.lastName));
        }
        if (relationship.referenceType == 'SECTION' && relationship.reference != null) {
          return /*#__PURE__*/React.createElement("div", {
            key: i
          }, /*#__PURE__*/React.createElement(Link, {
            to: "/groups/".concat(relationship.referenceID)
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "People"
          }), " ", relationship.reference.title));
        }
        if (relationship.referenceType == 'MEETING_INSTANCE' && relationship.reference != null) {
          return /*#__PURE__*/React.createElement("div", {
            key: i
          }, /*#__PURE__*/React.createElement(Link, {
            to: "/meetings/".concat(relationship.reference.meetingID, "/instance/").concat(relationship.referenceID)
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Agenda"
          }), " ", relationship.reference.title));
        }
        if (relationship.referenceType == 'POST' && relationship.reference != null) {
          return /*#__PURE__*/React.createElement("div", {
            key: i
          }, /*#__PURE__*/React.createElement(Link, {
            to: "/posts/".concat(relationship.referenceID)
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Post"
          }), " ", relationship.reference.title));
        }
        return null;
      });
    });
    _this.state = {
      guardianModalOpen: false
    };
    return _this;
  }
  _inherits(ConversationHeader, _Component);
  return _createClass(ConversationHeader, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        conversation = _this$props2.conversation,
        translate = _this$props2.translate;
      var hasRelationships = conversation != null && conversation.relationships.length > 0;
      var hasConversation = conversation != null && conversation.id != null && conversation.id !== 'new';
      return /*#__PURE__*/React.createElement("div", {
        className: "conversation conversation-header"
      }, hasRelationships || hasConversation ? /*#__PURE__*/React.createElement("div", {
        className: "meta-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "meta-links"
      }, hasRelationships ? this.renderMeta() : null), hasConversation ? /*#__PURE__*/React.createElement("div", {
        className: "guardian-membership-action"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.toggleGuardianModal
      }, translate('Manage participants')), /*#__PURE__*/React.createElement(GuardianMembershipModal, {
        isOpen: this.state.guardianModalOpen,
        onClose: this.toggleGuardianModal,
        conversation: conversation
      })) : null) : null);
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    user: state.User.user,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(ConversationHeader);